/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Select_Video_FileInputs */

const en_embed_captions_select_video_file = /** @type {(inputs: Embed_Captions_Select_Video_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a video file`)
};

const fr_embed_captions_select_video_file = /** @type {(inputs: Embed_Captions_Select_Video_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez selectionner un fichier video`)
};

const de_embed_captions_select_video_file = /** @type {(inputs: Embed_Captions_Select_Video_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie eine Videodatei aus.`)
};

const it_embed_captions_select_video_file = /** @type {(inputs: Embed_Captions_Select_Video_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un file video`)
};

const ru_embed_captions_select_video_file = /** @type {(inputs: Embed_Captions_Select_Video_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите видеофайл.`)
};

const es_embed_captions_select_video_file = /** @type {(inputs: Embed_Captions_Select_Video_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor seleccione un archivo de vídeo`)
};

const zh_cn2_embed_captions_select_video_file = /** @type {(inputs: Embed_Captions_Select_Video_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择一个视频文件`)
};

const ja_embed_captions_select_video_file = /** @type {(inputs: Embed_Captions_Select_Video_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオファイルを選択してください`)
};

const hi_embed_captions_select_video_file = /** @type {(inputs: Embed_Captions_Select_Video_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया एक वीडियो फ़ाइल चुनें`)
};

const pt_pt2_embed_captions_select_video_file = /** @type {(inputs: Embed_Captions_Select_Video_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, selecione um arquivo de vídeo.`)
};

/**
* | output |
* | --- |
* | "Please select a video file" |
*
* @param {Embed_Captions_Select_Video_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_select_video_file = /** @type {((inputs?: Embed_Captions_Select_Video_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Select_Video_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_select_video_file(inputs)
	if (locale === "de") return de_embed_captions_select_video_file(inputs)
	if (locale === "it") return it_embed_captions_select_video_file(inputs)
	if (locale === "ru") return ru_embed_captions_select_video_file(inputs)
	if (locale === "es") return es_embed_captions_select_video_file(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_select_video_file(inputs)
	if (locale === "ja") return ja_embed_captions_select_video_file(inputs)
	if (locale === "hi") return hi_embed_captions_select_video_file(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_select_video_file(inputs)
	return en_embed_captions_select_video_file(inputs)
});